export default __webpack_public_path__ + "static/media/sf5.aa66a949.svg";